// console.log("ah-popup.js loaded");

// (function () {

//   function getPopup() {
//     return document.querySelector(".popup-wrap");
//   }

//   function openPopup() {
//     var popup = getPopup();
//     if (!popup) return;
//     popup.classList.add("active");
//     document.documentElement.style.overflow = "hidden";
//   }

//   function closePopup() {
//     var popup = getPopup();
//     if (!popup) return;
//     popup.classList.remove("active");
//     document.documentElement.style.overflow = "";
//   }

//   function initPopup() {

//     document.addEventListener("click", function (e) {

//       if (e.target.closest(".open-popup")) {
//         e.preventDefault();
//         openPopup();
//         return;
//       }

//       if (e.target.closest(".close-popup")) {
//         closePopup();
//         return;
//       }

//       var popup = getPopup();
//       if (popup && popup.classList.contains("active")) {
//         var inner = popup.querySelector(".popup-inner-wrap");
//         if (inner && !inner.contains(e.target)) {
//           closePopup();
//         }
//       }

//     });

//     document.addEventListener("keydown", function (e) {
//       if (e.key === "Escape") {
//         closePopup();
//       }
//     });

//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", initPopup);
//   } else {
//     initPopup();
//   }

//   document.addEventListener("shopify:section:load", initPopup);
//   document.addEventListener("page:load", initPopup);

// })();

// console.log("ah-popup.js loaded");
// (function () {
//   function getPopup() {
//     return document.querySelector(".popup-wrap");
//   }
//   function openPopup() {
//     var popup = getPopup();
//     if (!popup) return;
//     popup.classList.add("active");
//     document.documentElement.style.overflow = "hidden";
//   }
//   function closePopup() {
//     var popup = getPopup();
//     if (!popup) return;
//     popup.classList.remove("active");
//     document.documentElement.style.overflow = "";
//   }
//   function initPopup() {
//     // --- NEW: Hide fields and show success message if memory exists ---
//     var popup = getPopup();
//     if (popup && sessionStorage.getItem('ah_popup_submitted') === 'true') {
//       var popupFields = popup.querySelector('.popup-fields');
//       var persistentSuccess = popup.querySelector('.js-persistent-success');
//       if (popupFields) popupFields.style.display = 'none';
//       if (persistentSuccess) persistentSuccess.style.display = 'block';
//     }
//     // ------------------------------------------------------------------
 
//     document.addEventListener("click", function (e) {
//       if (e.target.closest(".open-popup")) {
//         e.preventDefault();
//         openPopup();
//         return;
//       }
//       if (e.target.closest(".close-popup")) {
//         closePopup();
//         return;
//       }
//       var activePopup = getPopup();
//       if (activePopup && activePopup.classList.contains("active")) {
//         var inner = activePopup.querySelector(".popup-inner-wrap");
//         if (inner && !inner.contains(e.target)) {
//           closePopup();
//         }
//       }
//     });
//     document.addEventListener("keydown", function (e) {
//       if (e.key === "Escape") {
//         closePopup();
//       }
//     });
//   }
//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", initPopup);
//   } else {
//     initPopup();
//   }
//   document.addEventListener("shopify:section:load", initPopup);
//   document.addEventListener("page:load", initPopup);
// })();

// new code
(function () {
  function getPopup() {
    return document.querySelector(".popup-wrap");
  }
  function openPopup() {
    var popup = getPopup();
    if (!popup) return;
    popup.classList.add("active");
    document.documentElement.style.overflow = "hidden";
  }
  function closePopup() {
    var popup = getPopup();
    if (!popup) return;
    popup.classList.remove("active");
    document.documentElement.style.overflow = "";
    rememberPopupClose(popup);
  }
  function rememberPopupClose(popup) {
    var frequency = popup.dataset.popupFrequency || 'every_visit';
    if (frequency === 'session') {
      sessionStorage.setItem('ah_popup_closed', 'true');
    } else if (frequency === '7_days' || frequency === '30_days') {
      localStorage.setItem('ah_popup_closed_at', Date.now().toString());
    }
  }
  function wasRecentlyClosed(popup) {
    var frequency = popup.dataset.popupFrequency || 'every_visit';
    if (frequency === 'session') return sessionStorage.getItem('ah_popup_closed') === 'true';
    if (frequency === '7_days' || frequency === '30_days') {
      var closedAt = Number(localStorage.getItem('ah_popup_closed_at'));
      var days = frequency === '7_days' ? 7 : 30;
      return closedAt > 0 && Date.now() - closedAt < days * 86400000;
    }
    return false;
  }
  function initPopup() {
    var popup = getPopup();
    if (!popup || popup.dataset.popupInitialized === 'true') return;
    popup.dataset.popupInitialized = 'true';
    var hasSubmitted = sessionStorage.getItem('ah_popup_submitted') === 'true';
 
    // 1. Memory Check: Hide form and show success message if already submitted
    if (popup && hasSubmitted) {
      var popupFields = popup.querySelector('.popup-fields');
      var persistentSuccess = popup.querySelector('.js-persistent-success');
      if (popupFields) popupFields.style.display = 'none';
      if (persistentSuccess) persistentSuccess.style.display = 'block';
    }
 
    // 2. Auto-Open Logic: Open after 3 seconds IF not submitted
    if (!hasSubmitted && !wasRecentlyClosed(popup)) {
      var delay = Number(popup.dataset.popupDelay) || 0;
      setTimeout(function() {
         // Check to make sure they haven't manually opened it via a button before the timer fired
         if(!popup.classList.contains("active")){
             openPopup();
         }
      }, delay);
    }
 
    // 3. Event Listeners
    document.addEventListener("click", function (e) {
      if (e.target.closest(".open-popup")) {
        e.preventDefault();
        openPopup();
        return;
      }
      // Close popup if X is clicked (No memory saved, it will show again next page load)
      if (e.target.closest(".close-popup")) {
        closePopup();
        return;
      }
      // Close popup if clicking outside the white box
      var activePopup = getPopup();
      if (activePopup && activePopup.classList.contains("active")) {
        var inner = activePopup.querySelector(".popup-inner-wrap");
        if (inner && !inner.contains(e.target)) {
          closePopup();
        }
      }
    });
 
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closePopup();
      }
    });
  }
 
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPopup);
  } else {
    initPopup();
  }
  document.addEventListener("shopify:section:load", initPopup);
  document.addEventListener("page:load", initPopup);
})();
 
